import { fetchProductDescription } from '../../../services/api/request';

export const reportExample = {
    namespaced: true,
    state: {
        product: {},
    },
    mutations: {
        save(state, data) {
            state.product = data;
        }
    },
    actions: {
        fetchExample({ commit, dispatch }, productId) {
            return fetchProductDescription(productId)
                .then((res) => {
                    commit('save', res.data);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        }
    },
    getters: {
        isFetched({ product }) {
            return Object.keys(product).length > 0;
        },
        product({ product }) {
            return product;
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/reportExample/store.js